import { useEffect } from 'react'

const BASE_TITLE = 'Meal Planner'

/**
 * Put the current screen in the browser tab. `null` leaves the title alone, so
 * compact panels can sit inside a page that already owns it.
 */
export function useDocumentTitle(title: string | null) {
  useEffect(() => {
    if (title === null) return
    document.title = title ? `${title} · ${BASE_TITLE}` : BASE_TITLE
    return () => {
      document.title = BASE_TITLE
    }
  }, [title])
}
